export const FAQS = [
  {
    q: "How fast can you build an AI app?",
    a: "We ship marketing websites in a day, and full AI apps or AI agents in about a week. Our speed comes from tight scoping, a proven React + FastAPI + MongoDB stack, and AI baked in from day one.",
  },
  {
    q: "How much does it cost to build an AI app with vonmal?",
    a: "Pricing is lean and transparent. Websites start around $499 and full AI apps start around $1,999, scaling with the features you pick. Use our live 'Build Your App' estimator to get an instant price and timeline.",
  },
  {
    q: "What kinds of AI products do you build?",
    a: "We build AI apps (like jananibachpan.com), autonomous AI agents, marketing websites, and ACE AI domain-specific apps — all production-ready and easy to deploy.",
  },
  {
    q: "Do you build apps similar to jananibachpan.com?",
    a: "Yes. jananibachpan.com is one of our AI apps — a multilingual AI companion for pregnancy and motherhood. We can build a similar AI product tailored to your domain in about a week.",
  },
  {
    q: "Are your apps easy to deploy and go live?",
    a: "Absolutely. Every build ships deployment-ready with one-click deploy and custom domain support, so you can go live in minutes and scale as you grow.",
  },
  {
    q: "Where is vonmal located?",
    a: "vonmal operates from Jacksonville, Florida and Hyderabad, India, and works with clients worldwide.",
  },
];
